import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {getUtilisateursWithoutPagination} from '../../../../components/requests'
import {savErreur, updateSavDossier} from '../../../../components/sav/requests'
import {ModeleSavUtilisateur} from '../../../../components/sav/Models'

type Props = {
  dossierId: number
  assigne?: ModeleSavUtilisateur | null
  onClose: () => void
  onSaved: () => void
}

// Réassignation du dossier à un autre interlocuteur SAV
const SavReassignerModal = ({dossierId, assigne, onClose, onSaved}: Props) => {
  const [utilisateurs, setUtilisateurs] = useState<Array<ModeleSavUtilisateur>>([])
  const [choix, setChoix] = useState<string>(assigne?.id ? String(assigne.id) : '')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getUtilisateursWithoutPagination()
      .then((reponse: any) => setUtilisateurs(reponse?.data ?? []))
      .catch((e) => toast.error(savErreur(e)))
  }, [])

  const enregistrer = () => {
    setLoading(true)
    updateSavDossier(dossierId, {utilisateurAssigne: choix ? Number(choix) : null})
      .then(() => {
        toast.success('Dossier réassigné')
        onSaved()
      })
      .catch((e) => toast.error(savErreur(e)))
      .finally(() => setLoading(false))
  }

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Réassigner le dossier</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <select className='form-select' value={choix} onChange={(e) => setChoix(e.target.value)}>
          <option value=''>Non assigné</option>
          {utilisateurs.map((u) => (
            <option key={u.id} value={u.id}>
              {`${u.prenom ?? ''} ${u.nom ?? ''}`.trim()}
            </option>
          ))}
        </select>
      </Modal.Body>
      <Modal.Footer>
        <button className='btn btn-light' onClick={onClose} disabled={loading}>
          Annuler
        </button>
        <button className='btn btn-warning' onClick={enregistrer} disabled={loading}>
          Réassigner
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default SavReassignerModal
